<div [formGroup]="form()" class="space-y-2">
  @let reason = form().get("ntfReason");

  <app-pan-form-control>
    <app-pan-floating-label for="ntfReason">Reason</app-pan-floating-label>
    <div class="flex gap-2 items-start">
      <ng-select
        class="flex-1 min-w-0"
        formControlName="ntfReason"
        [items]="reasonOptions()"
        groupBy="category"
        bindLabel="label"
        placeholder="Select a reason..."
        data-testid="ntf-reason"
        [clearable]="true"
        [loading]="isLoadingData()"
        appendTo="body"
      >
        <ng-template ng-optgroup-tmp let-item="item">
          <span class="text-gray-500">{{ item.category }}</span>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <span>{{ item.label }}</span>
        </ng-template>
      </ng-select>
      <app-pan-button class="shrink-0" icon="refresh" (click)="refresh()"></app-pan-button>
    </div>
    @if (!reason?.value) {
      <div class="text-danger mt-1" role="alert" data-testid="ntf-reason-error">Please select a reason.</div>
    }
  </app-pan-form-control>

  @if (showCommentsField()) {
    <app-review-form-findings [form]="form()" [required]="true"></app-review-form-findings>
  }

  @if (errorMessage()) {
    <app-pan-inline-alert type="danger" class="mb-2" data-testid="ntf-reasons-load-error">
      Failed to load non-incident reasons: {{ errorMessage() }}
    </app-pan-inline-alert>
  }
</div>
